export interface Query {
  // 対象の便の便番号
  flightNumber: string,
  // 出発空港
  depAirport: string,
  // 到着空港
  arrAirport: string,
  // 出発空港の3レターコード
  fromAirportCode: string,
  // 到着空港の3レターコード
  toAirportCode: string,
  // 出発空港のターミナル名称
  fromTerminal: string,
  // 到着空港のターミナル名称
  toTerminal: string,
  // 対象便の出発予定日時
  std: Date | null,
  // 対象便の到着予定日時
  sta: Date | null,
  // 参照元を特定するためのパラメータ
  referrer: string,
  // 到着案内フラグ
  isArrivalGuide: boolean,
  // 画面の表示言語
  lang: Lang,
  // 国内線か
  isDomestic: boolean
}

// TOOO: LangClassと統合する
export enum Lang {
  ja = 'ja',
  en = 'en',
}

export const changeLang = (lang: string) => {
  switch(lang) {
    case 'ja':
      return Lang.ja;
    case 'en':
      return Lang.en;
    default:
      return Lang.ja;
  }
}
